const orderTabs = {
    IN_PROGRESS: '/in-progress',
    PAST: '/past-orders',
};

export default orderTabs;
